import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=f353672a&scoped=true"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"
import style0 from "./Call.vue?vue&type=style&index=0&id=f353672a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f353672a",
  null
  
)

export default component.exports